export const Estados = [
  { nome: 'Acre', sigla: 'AC', id: 12 },
  { nome: 'Alagoas', sigla: 'AL', id: 27 },
  { nome: 'Amapá', sigla: 'AP', id: 16 },
  { nome: 'Amazonas', sigla: 'AM', id: 13 },
  { nome: 'Bahia', sigla: 'BA', id: 29 },
  { nome: 'Ceará', sigla: 'CE', id: 23 },
  { nome: 'Distrito Federal', sigla: 'DF', id: 53 },
  { nome: 'Espírito Santo', sigla: 'ES', id: 32 },
  { nome: 'Goiás', sigla: 'GO', id: 52 },
  { nome: 'Maranhão', sigla: 'MA', id: 21 },
  { nome: 'Mato Grosso', sigla: 'MT', id: 51 },
  { nome: 'Mato Grosso do Sul', sigla: 'MS', id: 50 },
  { nome: 'Minas Gerais', sigla: 'MG', id: 31 },
  { nome: 'Pará', sigla: 'PA', id: 15 },
  { nome: 'Paraíba', sigla: 'PB', id: 25 },
  { nome: 'Paraná', sigla: 'PR', id: 41 },
  { nome: 'Pernambuco', sigla: 'PE', id: 26 },
  { nome: 'Piauí', sigla: 'PI', id: 22 },
  { nome: 'Rio de Janeiro', sigla: 'RJ', id: 33 },
  { nome: 'Rio Grande do Norte', sigla: 'RN', id: 24 },
  { nome: 'Rio Grande do Sul', sigla: 'RS', id: 43 },
  { nome: 'Rondônia', sigla: 'RO', id: 11 },
  { nome: 'Roraima', sigla: 'RR', id: 14 },
  { nome: 'Santa Catarina', sigla: 'SC', id: 42 },
  { nome: 'São Paulo', sigla: 'SP', id: 35 },
  { nome: 'Sergipe', sigla: 'SE', id: 28 },
  { nome: 'Tocantins', sigla: 'TO', id: 17 },
];

/**
 * Retorna as siglas de todos os estados passados por argumento
 * separadas por virgula
 *
 * e.g. de retorno "SP,PR"
 *
 * Caso não passe nenuhm argumento será retornado todas as siglas do estados
 *
 * @param {[string]} ufs estados que desejam recuperar as siglas
 */
export function getSiglaFromEstados(ufs = []) {
  if (ufs.length === 0) {
    return Estados.map(estado => estado.sigla).join(',');
  }

  return ufs.map(nome => Estados.find(uf => uf.nome === nome)?.sigla).join(',');
}
